import React from 'react';
import { Linkedin, Twitter } from 'lucide-react';
import { PrivacyControls } from './PrivacyControls';
export function Footer() {
  return <footer className="w-full bg-[#1a1d1f] py-12 px-6" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <div className="flex flex-col md:flex-row justify-between gap-12 mb-8" data-id="element-30">
          {/* Left Side - Logo and Description */}
          <div className="flex-1 max-w-2xl" data-id="element-31">
            <div className="mb-6" data-id="element-32">
              <img src="https://images.squarespace-cdn.com/content/v1/6356d3a6954945102e51363f/351c9b82-3d89-4452-9423-c60e9f2208c7/sp_logo_w.png" alt="Spaceport Logo" className="h-12 w-auto object-contain" data-id="element-33" />
            </div>
            <p className="text-white text-lg mb-8" data-id="element-34">
              Spaceport is based in the USA, backed by venture capital, boasting
              a global remote organization.
            </p>
          </div>
          {/* Right Side - Navigation and Social */}
          <div className="flex flex-col items-start md:items-end gap-6" data-id="element-35">
            {/* Social Icons */}
            <div className="flex gap-4" data-id="element-36">
              <a href="https://www.linkedin.com/company/spaceportxyz/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-white hover:text-gray-300 transition-colors" data-id="element-37">
                <Linkedin className="w-6 h-6" data-id="element-38" />
              </a>
              <a href="https://x.com/spaceportxyz" target="_blank" rel="noopener noreferrer" aria-label="X" className="text-white hover:text-gray-300 transition-colors" data-id="element-39">
                <Twitter className="w-6 h-6" data-id="element-40" />
              </a>
            </div>
            {/* Navigation Links */}
            <div className="flex flex-col gap-3 items-start md:items-end" data-id="element-41">
              <a href="https://spaceport.xyz/brands" className="text-white text-lg hover:text-gray-300 transition-colors underline" data-id="element-42">
                For Brands
              </a>
              <a href="https://spaceport.xyz/devs" className="text-white text-lg hover:text-gray-300 transition-colors underline" data-id="element-43">
                For Devs
              </a>
              <a href="https://spaceport.xyz/team" className="text-white text-lg hover:text-gray-300 transition-colors underline" data-id="element-44">
                The Team
              </a>
              <a href="https://spaceport.xyz/blog" className="text-white text-lg hover:text-gray-300 transition-colors underline" data-id="element-45">
                Blog
              </a>
            </div>
          </div>
        </div>
        {/* Legal Text */}
        <div className="mb-6" data-id="element-46">
          <p className="text-gray-500 text-sm" data-id="element-47">
            Roblox, Unreal and Fortnite trademark and logos are the property of
            their respective owners and are used for illustrative purposes only.
            Toei Animation assets are used under official license.
          </p>
        </div>
        {/* Copyright, Links, and Privacy Controls */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-48">
          <div className="flex flex-wrap items-center gap-2 text-sm" data-id="element-49">
            <span className="text-gray-500" data-id="element-50">
              ©2024 Spaceport All Rights Reserved
            </span>
            <span className="text-gray-500" data-id="element-51">|</span>
            <a href="https://spaceport.xyz/privacypolicy" className="text-gray-500 hover:text-gray-400 transition-colors" data-id="element-52">
              Privacy Policy
            </a>
            <span className="text-gray-500" data-id="element-53">|</span>
            <a href="https://spaceport.xyz/termsofservice" className="text-gray-500 hover:text-gray-400 transition-colors" data-id="element-54">
              Terms of Service
            </a>
          </div>
          <PrivacyControls data-id="element-55" />
        </div>
      </div>
    </footer>;
}